import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FtDataTableComponent } from './data-table.component';
import { FtFilterPopoverComponent } from './filters/ft-filter-popover.component';

/**
 * The account app's table stack. Since the Phase 5b cutover this is the ONLY one: AG Grid and
 * PrimeNG are uninstalled, and the per-table engine flag (TableEngineService / TABLE_ENGINE_OPTIONS /
 * the `ft_table_engine_<id>` localStorage override) is deleted along with every `!useTanstack` branch.
 *
 * Wired into AccountCommonModule so `<ft-data-table>` is available app-wide. There is no legacy
 * branch left to fall back to, which is why the parity gate compares against another WORKTREE rather
 * than against a flag — see account-parity/src/table/table-parity.ts.
 */
/**
 * `FtFilterPopoverComponent` is EXPORTED as well as imported: sponsor-custom-report supplies its own
 * `[headerTemplate]`, which replaces the wrapper's filter row and mounts the same headless controls
 * in its own `<th>`, so it needs the popover in ITS template too. It reaches it through
 * AccountCommonModule, which re-exports this module.
 */
@NgModule({
    declarations: [FtDataTableComponent],
    imports: [CommonModule, FtFilterPopoverComponent],
    exports: [FtDataTableComponent, FtFilterPopoverComponent],
})
export class TanStackGridModule {}
